module.exports = __webpack_public_path__ + "img/rocket.6e387cae.png";